import prognosisActions from "./prognosisActions";

export default prognosisActions;
